export const FluidPageContainer = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <div className="mx-[-20px] -mb-10 h-[calc(100vh-60px)] xl:-mx-[30px] xl:h-[calc(100vh-70px)]">
      {children}
    </div>
  );
};
